import {Component, OnInit, Input, NO_ERRORS_SCHEMA, NgModule, AfterViewInit} from '@angular/core';
import {FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators} from '@angular/forms';
import { Year } from '../year';
import {YearService} from '../year.service';
import {ActivatedRoute, Router} from '@angular/router';
import {SharedService} from '../../../../services/SharedService.service';
import {ConfirmationService, Message} from 'primeng/api';
import {MessageService} from 'primeng/components/common/messageservice';
import {NgbActiveModal, NgbModal, NgbModalOptions} from '@ng-bootstrap/ng-bootstrap';
import { AppLogComponent } from '../../../../components/app-log/app-log.component'
import {TranslateLoader, TranslateModule, TranslateService} from "@ngx-translate/core";
import {BrowserModule} from "@angular/platform-browser";
import {BrowserAnimationsModule} from "@angular/platform-browser/animations";
import {CommonModule} from "@angular/common";
import {ConfirmDialogModule, MessagesModule} from "primeng/primeng";
import {Http} from "@angular/http";
import {TranslateHttpLoader} from "@ngx-translate/http-loader";
import {RecordDataComponent} from "../../../../components/record-data";
import {AppArcComponent} from "../../../../components/app-arc";
import {OrganizationShowComponent} from "../../organization/organization-show/organization-show.component";
import {MyInputsModule} from "../../../../my-inputs/my-inputs.module";


@NgModule({
  imports:[CommonModule,FormsModule,MessagesModule,MyInputsModule,
    ReactiveFormsModule,ConfirmDialogModule,TranslateModule.forChild()
  ],
  declarations:[
    YearsShowComponent
  ],
  entryComponents: [
    YearsShowComponent
  ],
  exports:[],
  providers: [SharedService,YearService,MessageService,ConfirmationService],
  schemas: [NO_ERRORS_SCHEMA]
})

@Component({
  selector: 'app-years-show',
  templateUrl: './years-show.component.html',
  styleUrls: ['./years-show.component.scss'],
  providers: [YearService, ConfirmationService , MessageService]
})

export class YearsShowComponent implements OnInit, AfterViewInit  {
  year: string;
  yearobject = new Year("","","","","","");
  applog: AppLogComponent;
  @Input() delId;
  @Input() oldData;
  @Input() newData;
  @Input() newDatap;
  @Input() modelName;
  yearForm: FormGroup;
  statusVal = [{'val': 1, 'title': 'Active'}, {'val': 2, 'title': 'Inactive'}];
  yearsstatusVal = [{'val':1,'title':'Open'},
    {'val':2,'title':'Closed for Review'},
    {'val':3,'title':'Closed for Budget'}];

  calenderstatusVal = [{'val':1,'title':'Miladi'},
    {'val':2,'title':'Hajri'}];
  private sub: any;
  msgs: Message[] = [];

  private _editButton: any;
  private _deleteButton: any;
  private _newButton: any;
  private _printButton: any;
  private _searchButton: any;

  constructor(private route: ActivatedRoute,
              private router: Router,
              private sharedservice: SharedService,
              private yearService: YearService,
              private modalService: NgbModal,
              public activeModal: NgbActiveModal,
              public translate: TranslateService,
              private confirmationService: ConfirmationService,
              private messageService: MessageService) {
    const userdata = JSON.parse(localStorage.getItem('currentUser'));
    if(userdata && userdata.lang) {
      this.translate.use(userdata.lang);
    }
    this.sharedservice.setTitle(this.route.snapshot.data.title);
    this.sharedservice.setItemShow(YearsShowComponent);
    this.sharedservice.setButtons([
        { label: 'Delete', icon: 'fa-trash', btnClass: 'btn-danger', btnId: 'deleteButton' },
        { label: 'Edit', icon: 'fa-edit', btnClass: 'btn-warning', btnId: 'editButton' },
        // { label: 'Print', icon: 'fa-print', btnClass: 'btn-skype', btnId: 'printButton' },
        { label: 'Add', icon: 'fa-plus', btnClass: 'btn-info', btnId: 'newButton' },
        { label: 'Query', icon: 'fa-search', btnClass: 'btn-primary', btnId: 'searchButton' },
    ]);
    this.sharedservice.setModelName('years');
    this.modelName = this.sharedservice.getModelName();
    }
  ngAfterViewInit(){
      this._editButton = document.getElementById('editButton');
      this._deleteButton = document.getElementById('deleteButton');
      this._newButton = document.getElementById('newButton');
      this._printButton = document.getElementById('printButton');
      this._searchButton = document.getElementById('searchButton');

    if(this._editButton) {
          this._editButton.onclick = ((e: any) => {
              e.preventDefault();
              this.router.navigate(['/years/edit', this.year]);
          });
      }
      if(this._deleteButton) {
      this._deleteButton.onclick = ((e: any) => {
          e.preventDefault();
          this.deleteYear(this.yearobject);
      });}
          if(this._newButton) {
      this._newButton.onclick = ((e: any) => {
          e.preventDefault();
          this.router.navigate(['/years']);
      });}
      if(this._searchButton) {
          this._searchButton.onclick = ((e: any) => {
              e.preventDefault();
              this.router.navigate(['/years/search']);
          });

      }

  }
    recordData() {
        const options: NgbModalOptions = {

            beforeDismiss: () => {
                // this.changePicUrl();
                return true;
            }
        };
        const modalRef = this.modalService.open(RecordDataComponent, options);
        modalRef.componentInstance.refRec = this.yearobject;
        modalRef.componentInstance.rowId = '';

    }
  ngOnInit() {

    this.sub = this.route.params.subscribe(params => {
      this.year = params['id'];
    });

    var x = localStorage.getItem('showMessages');
    var st = localStorage.getItem('statusMessages');
    if(st == "" && x !=""){st="success";}
    //console.log(x);
    if(x!= "" && x != null){
      this.msgs = [];
      this.msgs.push({severity: st, summary: '', detail: this.translate.instant(x)});
    }
    localStorage.removeItem('showMessages');
    localStorage.removeItem('statusMessages');



    this.yearForm = new FormGroup({
      year: new FormControl({value:'', disabled: true}, Validators.required),
      calendar_type: new FormControl({value:'', disabled: true}, Validators.required),
      start_date: new FormControl({value:'', disabled: true}, Validators.required),
      end_date: new FormControl({value:'', disabled: true}, Validators.required),
      year_status: new FormControl({value:'', disabled: true}, Validators.required),

    });

    if(this.year) {
      this.activeModal.dismiss('');
      this.oldData = false;
      this.newData = false;
      this.newDatap = true;

      this.delId = false;
      localStorage.removeItem('filter');
      const msg = JSON.parse(localStorage.getItem('showMessages'));
      if(msg) {
        localStorage.removeItem('showMessages');
        this.msgs = msg;
        this.msgs = [];

      } 
      this.yearService.getById(this.year).subscribe(
        year => {
          this.year = year.year;
          this.yearobject=year;
          this.yearForm.patchValue({
            year: year.year,
            calendar_type: year.calendar_type,
                        start_date: year.start_date,
                        end_date: year.end_date,
                        year_status: year.year_status,

          });
        }, error => {
          console.log(error);
        }
      );


    }
    if(this.delId) {
      this.oldData = false;
      this.newData = false;
      this.newDatap = !this.newDatap ;
      this.yearService.getTrashedById(this.delId).subscribe(
        year => {
          this.year = year.year;
          this.yearobject = year;
          this.yearForm.patchValue({
            year: year.year,
            calendar_type: year.calendar_type,
                        start_date: year.start_date,
                        end_date: year.end_date,
                        year_status: year.year_status,
          });
        }, error => {
          console.log(error);
        }
      );
    }

    if(this.oldData && this.newData) {
      this.oldData['oldyear'] = this.newData.year;
      this.newData['oldyear'] = this.oldData.year;

      this.yearobject = this.newData;
      this.yearobject['oldyear'] = this.oldData.year;

      this.yearForm.patchValue({
        oldyear:this.oldData.year,
        year: this.newData.year,
        calendar_type: this.newData.calendar_type,
        start_date: this.newData.start_date,
        end_date: this.newData.end_date,
        year_status: this.newData.year_status,

      });
    }

    // console.log(this.newData);
    // console.log(this.oldData);
  }
    permissionAllow(button: string): boolean {
        let userRoles: any[] = [];
        const userdata = JSON.parse(localStorage.getItem('currentUser'));
        if (userdata) {
            userRoles = userdata.roles.description;
        }
        let role: string = '';
        switch (button) {
            case 'newButton': {
                role = 'create';
                break;
            }
            /*  case 'recordDataButton': {
                  role = 'recordData';
                  break;
              }*/
            case 'saveButton': {
                role = 'update';
                break;
            }
            case 'deleteButton': {
                role = 'delete';
                break;
            }
            case 'searchButton': {
                role = 'search';
                break;
            }
            case 'excelButton': {
                role = 'excel';
                break;
            }
            case 'printButton': {
                role = 'print';
                break;
            }
            case 'historyButton': {
                role = 'history';
                break;
            }
            case 'restoreButton': {
                role = 'restore';
                break;
            }
            case 'attachmentsButton': {
                role = 'attachments';
                break;
            }
            case 'rowinfo': {
                role = 'rowinfo';
                break;
            }

            default: {
                role = '';
                break;
            }
        }
        if(userRoles.indexOf('setting.years.'+role) >= 0) {
            return true;
        }
        return false;
    }
  deleteYear(year: Year) {
    this.confirmationService.confirm({
      header: this.translate.instant('Confirm Delete'),
      message: this.translate.instant('Are you sure of delete ?'),
      icon: 'fa fa-trash',
      accept: () => {
        if (year) {
          this.yearService.delete(year.year).subscribe(
            res => {
              this.msgs = [];
              this.msgs.push({severity: 'success', summary: '', detail: this.translate.instant('Delete completed')});
              setTimeout(()=> {
                  this.router.navigate(['/years/list']);
              },1000);
                //localStorage.setItem('showMessages', JSON.stringify(this.msgs));
                window.scroll(0,0);

            }
          );
        }
      }
    });
  }

  recoverEdit(year: Year) {
    this.confirmationService.confirm({
      header: this.translate.instant('Confirm Undo Edit'),
      message: this.translate.instant('Are you sure of undo ?. All data will be recover as seen in screen and any other editing will be dismiss'),
      icon: 'fa fa-undo',
      accept: () => {
        if (year) {
          this.yearService.update(year).subscribe(
            res => {

              if(res.year !="0"){

                this.msgs = [];
                this.msgs.push({severity: 'success', summary: '', detail: res.message});
                this.yearForm.reset();
                localStorage.setItem('showMessages', 'Data returned');
                localStorage.setItem('statusMessages', "success");
                this.activeModal.close('done');
                this.router.navigate(['/years/show',year.year]);
              }else{

                this.msgs = [];
                //console.log(ryear.message);
                localStorage.setItem('showMessages', res.message);
                localStorage.setItem('statusMessages', "error");
                for (let item of res.message) {
                  this.msgs.push({severity: 'error', summary: '', detail: this.translate.instant(item)});
                }
                this.activeModal.close('done');
                this.router.navigate(['/years/show',year.oldyear]);

              }
              // this.msgs = [];
              // this.msgs.push({severity: 'success', summary: '', detail: this.translate.instant('Data returned')});

            }
          );
        }
      }
    });
  }

  undotrashed() {
    this.confirmationService.confirm({
      header: this.translate.instant('Confirm Undo Delete'),
      message: this.translate.instant('Are you sure about recover deleted item?'),
      icon: 'fa fa-undo',
      accept: () => {
        if (this.delId) {
          this.yearService.restoreTrashedById(this.delId).subscribe(
            res => {
              this.msgs = [];
              this.msgs.push({severity: 'success', summary: '', detail: this.translate.instant('Deleted item recovered')});
              this.activeModal.dismiss('close click');
              this.router.navigate(['/years/list']);
            }
          );
        }
      }
    });
  }

  showattachement(row_id: string) {
    if (row_id) {
      const options: NgbModalOptions = {

        beforeDismiss: () => {
          // this.changePicUrl();
          return true;
        }
      };
      const modalRef = this.modalService.open(AppArcComponent, options);
      modalRef.componentInstance.rowId = row_id;
      modalRef.componentInstance.screenName = this.modelName;
    }
  }

  showHistory(row_id: string) {
    if (row_id) {
      const modalRef = this.modalService.open(AppLogComponent);
      modalRef.componentInstance.rowId = row_id;
      modalRef.componentInstance.refShow = YearsShowComponent;
    }
  }
}


// WEBPACK FOOTER //
// ./src/app/views/setting/years/years-show/years-show.component.ts